/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Content_Feature_2_TitleInputs */

const en_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short Game Area`)
};

const es_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona de juego corto`)
};

const de_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzspielbereich`)
};

const zh_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短杆区`)
};

const ar_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منطقة اللعب القصير`)
};

const fr_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone de petit jeu`)
};

const vi_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khu tập lối chơi ngắn`)
};

const sw_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eneo la mchezo mfupi`)
};

const th_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พื้นที่ฝึกลูกสั้น`)
};

const bs_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona za kratku igru`)
};

const ja_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショートゲームエリア`)
};

const ko_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`숏게임 구역`)
};

const pt_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Área de jogo curto`)
};

const it_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area gioco corto`)
};

const sv_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Närspelsområde`)
};

const nl_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korte-spelgebied`)
};

const da_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Område til det korte spil`)
};

const nb_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Område for kortspill`)
};

const fi_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähipelialue`)
};

const pl_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strefa krótkiej gry`)
};

const ru_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зона короткой игры`)
};

const tr_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kısa oyun alanı`)
};

const hi_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉर्ट गेम क्षेत्र`)
};

const id_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area short game`)
};

const ms_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kawasan permainan pendek`)
};

const cs_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zóna pro krátkou hru`)
};

const el_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χώρος κοντινού παιχνιδιού`)
};

const he_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אזור משחק קצר`)
};

const af_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kortspelarea`)
};

const hu_range_content_feature_2_title = /** @type {(inputs: Range_Content_Feature_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rövidjáték-terület`)
};

/**
* | output |
* | --- |
* | "Short Game Area" |
*
* @param {Range_Content_Feature_2_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_content_feature_2_title = /** @type {((inputs?: Range_Content_Feature_2_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Content_Feature_2_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_content_feature_2_title(inputs)
	if (locale === "de") return de_range_content_feature_2_title(inputs)
	if (locale === "zh") return zh_range_content_feature_2_title(inputs)
	if (locale === "ar") return ar_range_content_feature_2_title(inputs)
	if (locale === "fr") return fr_range_content_feature_2_title(inputs)
	if (locale === "vi") return vi_range_content_feature_2_title(inputs)
	if (locale === "sw") return sw_range_content_feature_2_title(inputs)
	if (locale === "th") return th_range_content_feature_2_title(inputs)
	if (locale === "bs") return bs_range_content_feature_2_title(inputs)
	if (locale === "ja") return ja_range_content_feature_2_title(inputs)
	if (locale === "ko") return ko_range_content_feature_2_title(inputs)
	if (locale === "pt") return pt_range_content_feature_2_title(inputs)
	if (locale === "it") return it_range_content_feature_2_title(inputs)
	if (locale === "sv") return sv_range_content_feature_2_title(inputs)
	if (locale === "nl") return nl_range_content_feature_2_title(inputs)
	if (locale === "da") return da_range_content_feature_2_title(inputs)
	if (locale === "nb") return nb_range_content_feature_2_title(inputs)
	if (locale === "fi") return fi_range_content_feature_2_title(inputs)
	if (locale === "pl") return pl_range_content_feature_2_title(inputs)
	if (locale === "ru") return ru_range_content_feature_2_title(inputs)
	if (locale === "tr") return tr_range_content_feature_2_title(inputs)
	if (locale === "hi") return hi_range_content_feature_2_title(inputs)
	if (locale === "id") return id_range_content_feature_2_title(inputs)
	if (locale === "ms") return ms_range_content_feature_2_title(inputs)
	if (locale === "cs") return cs_range_content_feature_2_title(inputs)
	if (locale === "el") return el_range_content_feature_2_title(inputs)
	if (locale === "he") return he_range_content_feature_2_title(inputs)
	if (locale === "af") return af_range_content_feature_2_title(inputs)
	if (locale === "hu") return hu_range_content_feature_2_title(inputs)
	return en_range_content_feature_2_title(inputs)
});